import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog'
import { Button } from './ui/button'
import { Video } from 'lucide-react'
import { parseVideoList, setVideoIds, getVideoIds, isUsingDefault } from '../video'

export function VideoSetup() {
  const [open, setOpen] = useState(false)
  const [input, setInput] = useState(() => getVideoIds().join('\n'))
  const [isDefault, setIsDefault] = useState(() => isUsingDefault())
  const [error, setError] = useState<string | null>(null)

  function openModal() {
    // Recargar el contenido del textarea desde localStorage al abrir.
    setInput(getVideoIds().join('\n'))
    setIsDefault(isUsingDefault())
    setError(null)
    setOpen(true)
  }

  function handleSave(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    const { ids, errors } = parseVideoList(input)
    if (errors.length > 0) {
      setError(`No reconozco: ${errors.slice(0, 3).join(', ')}${errors.length > 3 ? '...' : ''}`)
      return
    }
    setVideoIds(ids)
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Configurar video de fondo"
        onClick={openModal}
      >
        <Video className="h-5 w-5" />
      </Button>
      <DialogContent aria-label="Video de fondo" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>
            Video de fondo {isDefault && <span className="text-xs text-zinc-500 font-normal">(usando default)</span>}
          </DialogTitle>
          <DialogDescription>
            Una URL de YouTube por línea (video, playlist o ID directo). Si hay más de uno,
            el dashboard rota cada 15 minutos. Deja el campo vacío y guarda para quitar el
            fondo.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSave} className="space-y-4">
          <label className="block">
            <span className="sr-only">URLs del video</span>
            <textarea
              aria-label="URLs del video"
              placeholder={'https://www.youtube.com/watch?v=...\nhttps://youtu.be/...\nID11chars'}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              rows={6}
              className="w-full rounded-md border border-zinc-700 bg-zinc-900 px-3 py-2 text-sm font-mono text-zinc-100 placeholder-zinc-600 focus:border-zinc-500 focus:outline-none"
            />
          </label>
          {error && (
            <p role="alert" className="text-sm text-red-400">
              {error}
            </p>
          )}
          <div className="flex justify-end">
            <Button type="submit">Guardar</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
